import { APIcaller } from './APIcaller';

const generateToken = (userId) => APIcaller.apiGet(`/sleekplan/generateToken/${userId}`);

export default {
  generateToken,
};
